const deparam = () => {
  let queryString = {};
  let uri = window.location.search;
  uri.replace(new RegExp("([^?=&]+)(=([^&#]*))?", "g"), ($0, $1, $2, $3) => queryString[$1] = decodeURIComponent($3.replace(/\+/g, '%20')));
  return queryString;
}

const HOST = window.theme.host;
const ID = deparam().id ? deparam().id : window.location.href.substring(window.location.href.lastIndexOf("-") + 1, window.location.href.length); 
const carHandle = deparam().id ? deparam().id : window.location.href.substring(window.location.href.lastIndexOf("/") + 1, window.location.href.lastIndexOf("-")); 
const mainSpinner = document.querySelector('.galleryListingSpinner');
const mainContainer = document.querySelector('.GalleryListing__container');
const mainImageContainer = document.querySelector('.GalleryListing__mainImage');
const thumbsContainer = document.querySelector('.GalleryListing__thumbs');
const timelineContainer = document.querySelector('.GalleryListing__timeline');
const timelineHeaderContainer = document.querySelector('.GalleryListing__timeline--header');
const timelineEntryContainer = document.querySelector('.GalleryListing__timeline--entry-wrap');
const LikeButton = document.querySelector('.likeButton');
const likesContainer = document.querySelector('.likeListing span');

const postLike = async () => {
  try {
    const data = {
      customer: document.querySelector('#likeButton').getAttribute('data-cid'),
      listing: ID
    };
    const response = await axios.post(`${HOST}/like`, data, {headers: {
      shop: window.theme.shop
    }});
    likesContainer.textContent = `${response.data.count}`;
    LikeButton.style.display = 'none';
  } catch(e) {console.log('Error posting link', e);}
}

if (LikeButton) { 
  LikeButton.addEventListener('click', e => {
    e.preventDefault();
    postLike();
  });
}


const getListing = async () => {
  try {
    if (!ID) {return window.location.replace('/pages/gallery');}
    const response = await axios.get(`${HOST}/gallery_listing?id=${ID}`);
    console.log('response ', response.data.listing.listing);
    if (response.data.listing.listing.maintenanceMods.length >= 1) {
      mapMaintenceMods(response.data.listing.listing.maintenanceMods);    
    }
    mapImages(response.data.listing.listing.images);
    mapContent(response.data.listing.listing, response.data.listing.igName.trim(), response.data.likes.count);
  } catch(e) {console.log('Error loading listing', e);}
}
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const mapMaintenceMods = maintMods => {
  // console.log('maintmods:', maintMods);
  
  // Initial sort of timeline entries
  const sortByDate = arr => {
    const sorter = (a, b) => {
        return new Date(a.dateModified).getTime() - new Date(b.dateModified).getTime();
    }
    arr.sort(sorter);
  };
  sortByDate(maintMods);
  // console.log('sorted: ', maintMods);

  maintMods.forEach(maintMod => {
    const maintDiv = document.createElement('div');
    let date = new Date(maintMod.dateModified);

    let modAddedLabel, notesLabel, servicePerformedLabel, imagesLabel = `<div class="do-not-show"></div>`;

    if (maintMod.modsAdded !== '') {
      console.log('in if for mods added', maintMod);
      if (maintMod.productHandle) {
        var handleActual = maintMod.productHandle.split('__')[0].trim();
        var handleFor = maintMod.productHandle.split('__handle-for-')[1].trim();
        var isFullURL = handleActual.includes('.co');
        // console.log('maintMod product handle ', handleActual, ' and ', handleFor);

        if (maintMod.modsAdded.indexOf(',') > -1) {
          let newModArray = maintMod.modsAdded.split(',');
          let modStringList = '';
          let index = 0;
          newModArray.forEach(modString => {
            // console.log('index ', index);
            modString = modString.trim();
            modString = capitalizeFirstLetter(modString)
            // console.log(modString);
            // console.log(handleFor);
            if (modString == handleFor) {
              if (isFullURL) {
                modStringList += `<a href="${handleActual}" target="_blank">${modString}</a>`;
              } else {
                modStringList += `<a href="/products/${handleActual}" target="_blank">${modString}</a>`;                
              }
            } else {
              modStringList += `<span>${modString}</span>`;
            }
            index++;
            if (index < newModArray.length) {
              modStringList += ', ';
            }
          });
          modAddedLabel = `
          <p class='maint-title'>Mods Added:</p>
          <p class='maint-item'>${modStringList}</p>
          `;
        } else {
          if (isFullURL) {
            modAddedLabel = `
            <p class='maint-title'>Mods Added:</p>
            <p class='maint-item'><a href="${slugify(maintMod.productHandle)}" target="_blank">${maintMod.modsAdded}</a></p>
            `;
          } else {
            modAddedLabel = `
            <p class='maint-title'>Mods Added:</p>
            <p class='maint-item'><a href="/products/${slugify(maintMod.productHandle)}" target="_blank">${maintMod.modsAdded}</a></p>
            `;                
          }         
        }
        
      } else {
        modAddedLabel = `
        <p class='maint-title'>Mods Added:</p>        
        <p class='maint-item'>${maintMod.modsAdded}</p>
        `;
      }
      // modAddedLabel = `
      //   <p class='maint-title'>Mods Added:</p>
      //   <p class='maint-item'>- ${maintMod.modsAdded}<p>
      // `
    }
    if (maintMod.notes !== '') {
      // console.log('in if for notes added', maintMod);
      notesLabel = `
        <p class='maint-title'>Notes:</p>
        <p class='maint-item'>- ${maintMod.notes}<p>
      `
    }
    if (maintMod.servicePerformed !== '') {
      // console.log('in if for services added', maintMod);
      servicePerformedLabel = `
        <p class='maint-title'>Service Performed:</p>
        <p class='maint-item'>- ${maintMod.servicePerformed}<p>
      `
    }
    if (maintMod.images.length >= 1) {
      let imageTags = ``;
      let imgs = ``;
      maintMod.images.forEach(img => {
        let newImgTag = `<img class='maint-item__img' src='${HOST}/image/${img.split('/image/')[1]}'></img>`
        imgs = imageTags.concat(newImgTag)
      });
      // console.log('imageTags ', imgs);
      imagesLabel = `
        <p class='maint-title'>Mod Images:</p>
        <div class='maint-item__img-wrap'>${imgs}<div>
      `
    }

    modAddedLabel = maintMod.modsAdded !== '' ? modAddedLabel : '';
    servicePerformedLabel = maintMod.servicePerformed !== '' ? servicePerformedLabel : '';
    notesLabel = maintMod.notes !== '' ? notesLabel : '';
    if (maintMod.images.length < 1) {
      imagesLabel = '';
    }
    // console.log('images? ', imagesLabel);


    let allModsList = `
      ${modAddedLabel}
      ${servicePerformedLabel}
      ${notesLabel}
      ${imagesLabel}
    `;

    maintDiv.innerHTML = `
      <div class="GalleryListing__timeline--maint-wrap">
        <h6 class="GalleryListing__timeline--maint-date">${date.toLocaleDateString("en-US")}</h6>
        <div class='GalleryListing__timeline--maint-list'>
          <p class='mileageLabel'>Mileage: ${maintMod.mileage}</p>
          ${allModsList}
        </div>
      </div>
    `;

    timelineEntryContainer.append(maintDiv);
  });
  document.querySelector('.GalleryListing__timeline--sort').addEventListener('click', e => {
    let parent = timelineEntryContainer;
    let label = document.querySelector('.GalleryListing__timeline--sort');
    if (label.innerHTML == 'Sort: Oldest to Newest') {
      label.innerHTML = 'Sort: Newest to Oldest'
    } else {
      label.innerHTML = 'Sort: Oldest to Newest'
    }
    parent.append(...Array.from(parent.childNodes).reverse());  
  });
}

const mapImages = images => {
  mainImageContainer.innerHTML = `<img src="${HOST}/image/${images[0].split('/image/')[1]}"/>`;
  
  mainImageContainer.innerHTML = `
    <div class="mainImageContainer">
      <div class="Listing__spinner"> <div class="lds-ring"><div></div><div></div><div></div><div></div></div> </div>
      <img alt='Featured image for ${carHandle.replaceAll('-', ' ')}' src="${HOST}/image/${images[0].split('/image/')[1]}"/>
    </div>
  `;

  mainImageContainer.querySelector('img').onload = () => mainImageContainer.classList.add('loaded');


  
  images.forEach(image => {
    const a = document.createElement('a');
    a.innerHTML = `
      <div class="thumbImageContainer">
        <div class="Listing__spinner"> <div class="lds-ring"><div></div><div></div><div></div><div></div></div> </div>
        <img alt='Alternate image for ${carHandle.replaceAll('-', ' ')}' src="${HOST}/image/thumb_${image.split('/image/')[1]}">
      </div>
    `;

    const srcValue = `${HOST}/image/${image.split('/image/')[1]}`;
    a.setAttribute('data-image-value', srcValue);

    a.addEventListener('click', e => {
      e.preventDefault();
      mainImageContainer.querySelector('img').src = srcValue;
    });

    a.querySelector('img').onload = () => a.classList.add('loaded');

    thumbsContainer.append(a);
  });
}

const mapContent = (listing, igName, likes) => {
  const {year, selectedCar} = listing;
  const title = document.querySelector('.listingTitle');
  const igText = document.querySelector('.igName');
  const photographerIgText = document.querySelector('.photographerIgName');
  const modSections = document.querySelectorAll('.GalleryListing__modSection');
  const likesSection = document.querySelector('.likeListing span');
  
  title.textContent = `${year} ${selectedCar}`;
  document.title = `${year} ${selectedCar}`;
  
  if (igName) {
    const cleanedName = igName.replace(/@/g, '');
    igText.querySelector('a').textContent = '@' + cleanedName;
    igText.querySelector('a').href = `https://www.instagram.com/${cleanedName}`;
    igText.querySelector('a').target = '_blank';
  } else {
    igText.style.display = 'none';
  }
  if(likes > 0){
     likesSection.textContent = `${likes}`;
  }

  if (listing.photographerIg) {
    photographerIgText.querySelector('a').textContent = '@' + listing.photographerIg;
    photographerIgText.querySelector('a').href = `https://www.instagram.com/${listing.photographerIg}`;
    photographerIgText.querySelector('a').target = '_blank';
  } else {
    photographerIgText.style.display = 'none';
  }

  const bcContainer = document.querySelector('.breadcrumb.hidden-xs');
  const baseURL = '/pages/gallery';
  let bcString = `<a href="${baseURL}">Gallery</a>`;
  bcString += '<span class="nextArr">></span>';
  bcString += `<a href="${baseURL}?make=${listing.make}">${listing.make}</a>`;
  bcString += '<span class="nextArr">></span>';
  bcString += `<a href="${baseURL}?make=${listing.make}&series=${listing.series}">${listing.series}</a>`;
  bcString += '<span class="nextArr">></span>';
  bcString += `<a>${listing.chassis}</a>`;
  bcString += `
  <script type="application/ld+json">
    {
    "@context":"https://schema.org",
    "@type":"BreadcrumbList",
    "itemListElement":[
      {
        "@type":"ListItem",
        "position":1,
        "item":{
          "@id":"https://www.urotuning.com/",
          "name":"Home"
        }
      },
      {
        "@type":"ListItem",
        "position":2,
        "item":{
          "@id":"/pages/gallery",
          "name":"dasGallery"
        }
      },
      {
        "@type":"ListItem",
        "position":3,
        "item":{
          "@id":"/pages/gallery?make=${listing.make}",
          "name":"${listing.make} dasGallery"
        }
      },
      {
        "@type":"ListItem",
        "position":4,
        "item":{
          "@id":"${baseURL}?make=${listing.make}&series=${listing.series}",
          "name":"${listing.make} ${listing.series} dasGallery"
        }
      }
    ]
  }
  </script>
  `
  
  bcContainer.innerHTML = bcString;
  
  modSections.forEach(section => {
    const modCat = section.dataset.mods;
    const modList = listing[modCat];
    
    if (modList.length === 0) {return section.style.display = 'none';}
    const container = section.querySelector('ul');

    
    modList.forEach(mod => {
      const li = document.createElement('li');
      const value = capitalizeFirstLetter(mod.value);
      
      

      if (mod.productHandle) {
        var isFullURL = mod.productHandle.includes('.co');
        if (isFullURL) {
          li.innerHTML = `<p><a href="${mod.productHandle}" target="_blank">${value}</a></p>`;
        } else {
          li.innerHTML = `<p><a href="/products/${slugify(mod.productHandle)}" target="_blank">${value}</a></p>`;             
        }
        
      } else {
        li.innerHTML = `<p>${mod.value}</p>`;
      }
      container.append(li);
    });
  });

  if (listing.wheelsAndTiresSameSize) {
    document.querySelector('.GalleryListing__sameSizeWheels').style.display = 'block';
    document.querySelector('.GalleryListing__differentWheels').style.display = 'none';
  } else {
    document.querySelector('.GalleryListing__differentWheels').style.display = 'block';
    document.querySelector('.GalleryListing__sameSizeWheels').style.display = 'none';
  }

  const wheelBrandOrModel = document.querySelector('.wheelItem[data-value="wheelBrandOrModel"]');
  const differentSizeWheelBrandOrModel = document.querySelector('.GalleryListing__differentWheels .wheelItem[data-value="wheelBrandOrModel"]')
  const tireBrandOrModel = document.querySelector('.wheelItem[data-value="tireBrandOrModel"]');
  const frontWheelSpacers = document.querySelector('.wheelItem[data-value="frontWheelSpacers"]');
  const rearWheelSpacers = document.querySelector('.wheelItem[data-value="rearWheelSpacers"]');
  let hasWheelData = false;
  
  if (listing.wheelBrandOrModel) {
    if (listing.wheelsAndTiresSameSize) {
      wheelBrandOrModel.textContent = listing.wheelBrandOrModel; 
    } else {
      differentSizeWheelBrandOrModel.textContent = listing.wheelBrandOrModel; 
    }
    hasWheelData = true;
    const value = capitalizeFirstLetter(listing.wheelBrandOrModel);
    if (listing.wheelBrandOrModelLinkHandle) {      
      if (!listing.wheelBrandOrModelLinkHandle.includes('/')) {
        wheelBrandOrModel.innerHTML = `<a href="/products/${listing.wheelBrandOrModelLinkHandle}" target="_blank">${value}</a>`
      } else {
        wheelBrandOrModel.innerHTML = `<a href="${listing.wheelBrandOrModelLinkHandle}" target="_blank">${value}</a>`
      }
    }
  } else {
    wheelBrandOrModel.style.display = 'none';
  }
  
  if (listing.tireBrandOrModel) {
    tireBrandOrModel.textContent = listing.tireBrandOrModel;
    hasWheelData = true;
  } else {
    tireBrandOrModel.style.display = 'none';
  }
  if (listing.frontWheelSpacers && listing.frontWheelSpacers !== 'None') {
    if (listing.frontWheelSpacersLinkHandle) {
      if (!listing.frontWheelSpacersLinkHandle.includes('/')) {
        frontWheelSpacers.innerHTML = `<a href="/products/${listing.frontWheelSpacersLinkHandle}" target="_blank">${listing.frontWheelSpacers} Front Wheel Spacers</a>`
      } else {
        frontWheelSpacers.innerHTML = `<a href="${listing.frontWheelSpacersLinkHandle}" target="_blank">${listing.frontWheelSpacers} Front Wheel Spacers</a>`
      }      
    } else {
      frontWheelSpacers.textContent = listing.frontWheelSpacers + ' ' + 'Front Wheel Spacers';
    }
    hasWheelData = true;
  } else {
    frontWheelSpacers.style.display = 'none';
  }
  if (listing.rearWheelSpacers && listing.rearWheelSpacers !== 'None') {
    if (listing.rearWheelSpacersLinkHandle) {
      if (!listing.rearWheelSpacersLinkHandle.includes('/')) {
        rearWheelSpacers.innerHTML = `<a href="/products/${listing.rearWheelSpacersLinkHandle}" target="_blank">${listing.rearWheelSpacers} Rear Wheel Spacers</a>`
      } else {
        rearWheelSpacers.innerHTML = `<a href="${listing.rearWheelSpacersLinkHandle}" target="_blank">${listing.rearWheelSpacers} Rear Wheel Spacers</a>`
      }  
    } else {
      rearWheelSpacers.textContent = listing.rearWheelSpacers + ' ' + 'Rear Wheel Spacers';
    }
    
    hasWheelData = true;
  } else {
    rearWheelSpacers.style.display = 'none';
  }


  if (listing.wheelsAndTiresSameSize) {
    const wheelSizeContainer = document.querySelector('.wheelItem[data-value="wheelSize"]');
    const tireSizeContainer = document.querySelector('.wheelItem[data-value="tireSize"]');
    let {diameter, width, offset, tireWidth, tireAspectRatio} = listing.sameSizeWheels;
    let wheelSizeText;
    let tireSizeText;

    if (diameter) {diameter = diameter.split(' ')[0];}
    if (width) {width = width.split(' ')[0];}


    if (diameter && width && offset) {
      wheelSizeText = `${diameter}x${width} et ${offset}`;
      hasWheelData = true;
    } else if (diameter && width) {
      wheelSizeText = `${diameter}x${width}`;
      hasWheelData = true;
    } else if (diameter) {
      wheelSizeText = `${diameter}"`;
      hasWheelData = true;
    }

    if (wheelSizeText) {
      wheelSizeContainer.querySelector('span').textContent = wheelSizeText;
    } else {
      wheelSizeContainer.style.display = 'none';
    }

    if (tireWidth && tireAspectRatio && diameter) {
      tireSizeText = `${tireWidth}/${tireAspectRatio}-${diameter}`;
      hasWheelData = true;
    } else if (tireWidth && tireAspectRatio) {
      tireSizeText = `${tireWidth}/${tireAspectRatio}`;
      hasWheelData = true;
    }

    if (tireSizeText) {
      tireSizeContainer.querySelector('span').textContent = tireSizeText;
    } else {
      tireSizeContainer.style.display = 'none';
    }
  } else {
    const wheelSizeContainerFront = document.querySelector('.wheelItem[data-value="wheelSizeFront"]');
    const tireSizeContainerFront = document.querySelector('.wheelItem[data-value="tireSizeFront"]');
    const wheelSizeContainerRear = document.querySelector('.wheelItem[data-value="wheelSizeRear"]');
    const tireSizeContainerRear = document.querySelector('.wheelItem[data-value="tireSizeRear"]');
    let {diameterFront, widthFront, offsetFront, tireWidthFront, tireAspectRatioFront, diameterRear, widthRear, offsetRear, tireWidthRear, tireAspectRatioRear} = listing.differentWheels;
    let wheelSizeTextFront;
    let tireSizeTextFront;
    let wheelSizeTextRear;
    let tireSizeTextRear;

    if (diameterFront) {diameterFront = diameterFront.split(' ')[0];}
    if (widthFront) {widthFront = widthFront.split(' ')[0];}
    if (diameterRear) {diameterRear = diameterRear.split(' ')[0];}
    if (widthRear) {widthRear = widthRear.split(' ')[0];}

    if (diameterFront && widthFront && offsetFront) {
      wheelSizeTextFront = `${diameterFront}x${widthFront} et ${offsetFront}`;
      hasWheelData = true;
    } else if (diameterFront && widthFront) {
      wheelSizeTextFront = `${diameterFront}x${widthFront}`;
      hasWheelData = true;
    } else if (diameterFront) {
      wheelSizeTextFront = `${diameterFront}"`;
      hasWheelData = true;
    }

    if (wheelSizeTextFront) {
      wheelSizeContainerFront.querySelector('span').textContent = wheelSizeTextFront;
    } else {
      wheelSizeContainerFront.style.display = 'none';
    }

    if (diameterRear && widthRear && offsetRear) {
      wheelSizeTextRear = `${diameterRear}x${widthRear} et ${offsetRear}`;
      hasWheelData = true;
    } else if (diameterRear && widthRear) {
      wheelSizeTextRear = `${diameterRear}x${widthRear}`;
      hasWheelData = true;
    } else if (diameterRear) {
      wheelSizeTextRear = `${diameterRear}"`;
      hasWheelData = true;
    }

    if (wheelSizeTextRear) {
      wheelSizeContainerRear.querySelector('span').textContent = wheelSizeTextRear;
    } else {
      wheelSizeContainerRear.style.display = 'none';
    }

    if (tireWidthFront && tireAspectRatioFront && diameterFront) {
      tireSizeTextFront = `${tireWidthFront}/${tireAspectRatioFront}-${diameterFront}`;
      hasWheelData = true;
    } else if (tireWidthFront && tireAspectRatioFront) {
      tireSizeTextFront = `${tireWidthFront}/${tireAspectRatioFront}`;
      hasWheelData = true;
    }

    if (tireSizeTextFront) {
      tireSizeContainerFront.querySelector('span').textContent = tireSizeTextFront;
    } else {
      tireSizeContainerFront.style.display = 'none';
    }

    if (tireWidthRear && tireAspectRatioRear && diameterRear) {
      tireSizeTextRear = `${tireWidthRear}/${tireAspectRatioRear}-${diameterRear}`;
      hasWheelData = true;
    } else if (tireWidthRear && tireAspectRatioRear) {
      tireSizeTextRear = `${tireWidthRear}/${tireAspectRatioRear}`;
      hasWheelData = true;
    }

    if (tireSizeTextRear) {
      tireSizeContainerRear.querySelector('span').textContent = tireSizeTextRear;
    } else {
      tireSizeContainerRear.style.display = 'none';
    }
  }

  if (!hasWheelData) {
    document.querySelector('.GalleryListing__wheelsSection').style.display = 'none';
  }

  mainSpinner.classList.remove('active');
  mainContainer.style.display = 'flex';
}

getListing();

function slugify(string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}